<template>
  <nut-form-item :label="label" style="display: block; position: relative">
    <Searchbar v-if="searchStatus" v-model="searchValue" @search="search" />
    <nut-radio-group v-model="val" @change="onChange">
      <nut-radio shape="button" v-for="i in list" :key="i.value" :label="i.value">
        {{ i.text }}
      </nut-radio>
    </nut-radio-group>
  </nut-form-item>
</template>

<script setup>
const emit = defineEmits(['update:modelValue', 'change', 'search'])

const props = defineProps({
  modelValue: String,
  selectAll: {
    type: Boolean,
    default: false
  },
  searchStatus: {
    type: Boolean,
    default: false
  },
  label: {
    type: String,
    require: true
  },
  list: {
    type: Object,
    require: true
  }
})

const { label, modelValue, selectAll, searchStatus } = props
const searchValue = ref('')
function search() {}

function onChange(e) {
  emit('change', e)
}

const oldVal = ref(modelValue || [])
const val = ref(modelValue)
watch(
  () => props.modelValue,
  (val1) => {
    val.value = val1
  }
)
watch(
  val,
  (val1) => {
    emit('update:modelValue', val1)
  },
  {
    deep: true
  }
)
</script>

<style lang="scss" scoped>
::v-deep .nut-radio-group {
  display: flex;
  width: 100%;
  margin-top: 10px;
  flex-wrap: wrap;
  .nut-radio:last-child {
    margin-bottom: auto !important;
    margin-right: auto !important;
  }
  .nut-radio {
    margin: 10px;
    // margin-bottom: 10px;
  }
}
::v-deep .nut-radio__button {
  min-width: 80px;
  border-radius: 0;
  border: 1px solid #ebedf0 !important;
  background: #fff;
  justify-content: center;
}
::v-deep .nut-radio__button--active {
  color: #007296 !important;
  background: #fff2e5 !important;
  border: 1px solid #fff2e5 !important;
}
.selectall {
  position: absolute;
  right: 0;
  top: 20px;
}
::v-deep .nut-searchbar {
  padding: 0 !important;
}
</style>
